export const requestedScopes = ["profile", "email"];
